import {
  STATS_GET_ONBOARDING_REQUESTING,
  STATS_GET_ONBOARDING_SUCCESS,
  STATS_GET_ONBOARDING_ERROR,
  STATS_UPDATE
} from "./constants";

import { AUTH_LOGOUT_SUCCESS } from "../auth/reducer";

const initialState = {
  onboardingStats: {
    recruiting: 0,
    integration: 0,
    position: 0,
    training: 0,
    preparation: 0,
    briefing: 0,
    visualization: 0,
    debriefing: 0,
    capitalization: 0,
    teamCohesion: 0,
    motivation: 0,
    leadership: 0,
    confidence: 0,
    stress: 0,
    publicSpeaking: 0,
    numberOfFeedbacks: 1
  },
  requesting: false,
  error: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case STATS_GET_ONBOARDING_REQUESTING: {
      return {
        ...state,
        requesting: true
      };
    }

    case STATS_GET_ONBOARDING_SUCCESS: {
      return {
        ...state,
        onboardingStats: action.payload,
        requesting: false
      };
    }

    case STATS_GET_ONBOARDING_ERROR: {
      return {
        ...state,
        error: action.payload,
        requesting: false
      };
    }

    case STATS_UPDATE: {
      return { ...state, onboardingStats: action.payload };
    }

    case AUTH_LOGOUT_SUCCESS: {
      return { initialState };
    }

    default:
      return state;
  }
};

export default reducer;
